import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusIcon } from './NoonReportStatusIcon.styles';
import { CargoTempLogStatusEnum } from '../../../enums/cargoTempLogEnum';

export const CargoTempLogStatusIcon = (dateStatus: CargoTempLogStatusEnum) => {
    switch (dateStatus) {
        case CargoTempLogStatusEnum.configMissing:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="Missing config / Inhibitor questionnaire" />
                </StatusIcon>
            );
        case CargoTempLogStatusEnum.incomplete:
            return (
                <StatusIcon className="status-icon status-incomplete">
                    <FontAwesomeIcon icon="exclamation-circle" title="Incomplete" />
                </StatusIcon>
            );
        case CargoTempLogStatusEnum.complete:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Complete" />
                </StatusIcon>
            );
        case CargoTempLogStatusEnum.noCargo:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="exclamation-circle" title="No Cargo" />
                </StatusIcon>
            );
    }
};

export default CargoTempLogStatusIcon;
